import { useMemo } from "react";

import { useStore } from "../../stores/StoreContext";
import { TermsOfUseService } from "../LogicServices/TermsOfUseService";

export function useTermsOfUseService(): TermsOfUseService {
  const storeContext = useStore();
  return useMemo(() => new TermsOfUseService(storeContext), [storeContext]);
}
